export default {
  // Nav
  "nav.home": "Início",
  "nav.products": "Produtos",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Categorias",
  "nav.guides": "Guias",
  "nav.shoppingGuide": "Guia de Compras",
  "nav.mainSite": "Site Principal",
  "nav.about": "Sobre",
  "nav.contact": "Contato",
  "nav.disclaimer": "Aviso Legal",
  "nav.language": "Idioma",

  // Hero
  "hero.badge": "Recurso Independente · Atualizado 2026",
  "hero.title": "CSSBuy Spreadsheet: Encontre Links, Guias e Recursos para Comprar Melhor",
  "hero.subtitle": "Explore o CSSBuy Spreadsheet, descubra categorias populares, encontre recursos úteis e aprenda como verificar produtos, QC, medidas, warehouse e shipping antes de comprar.",
  "hero.cta1": "Explorar CSSBuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.trust1": "Recurso Independente",
  "hero.trust2": "Guias Atualizados 2026",
  "hero.trust3": "Pesquisa Organizada",
  "hero.trust4": "Informações de Segurança",

  // Categories dropdown
  "nav.categories.label": "Categorias",
  "cat.shoes": "Tênis / Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "Camisetas / T-Shirts",
  "cat.jackets": "Jaquetas / Jackets",
  "cat.pants": "Calças / Pants & Shorts",
  "cat.headwear": "Chapéus / Headwear",
  "cat.sets": "Conjuntos / Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Camisas / Jersey",
  "cat.accessories": "Acessórios / Accessories",
  "cat.bags": "Bolsas / Bags",
  "cat.belts": "Cintos / Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Outros / Other Stuff",

  // Products page
  "products.title": "Catálogo de Produtos",
  "products.subtitle": "Explore nossa coleção curada de produtos. Clique em qualquer item para ver detalhes e comprar.",
  "products.allCategories": "Todas as Categorias",
  "products.searchPlaceholder": "Buscar produtos...",
  "products.clear": "Limpar",
  "products.showing": "Mostrando",
  "products.items": "itens",
  "products.noResults": "Nenhum produto encontrado",
  "products.viewAll": "Ver Todos os Produtos",
  "what.title": "O que é o CSSBuy Spreadsheet?",
  "what.text": "Um CSSBuy Spreadsheet organiza links, produtos, categorias e recursos de compra em um formato simples de pesquisar. Nosso objetivo é ajudar compradores a encontrar informações e tomar decisões mais informadas. Este é um recurso independente, não afiliado ao CSSBuy.",
  "what.disclaimer": "Este website é um recurso informacional independente e não é afiliado, endossado ou operado pelo CSSBuy.",

  // Categories section
  "cats.title": "Encontre o que você procura",
  "cats.subtitle": "Navegue por categorias populares no CSSBuy Spreadsheet",
  "cats.viewAll": "Ver Todos",
  "cats.explore": "Explorar",

  // Why section
  "why.title": "Por que usar nosso CSSBuy Spreadsheet?",
  "why.1": "Links organizados por categoria",
  "why.2": "Categorias simples e intuitivas",
  "why.3": "Guias para iniciantes",
  "why.4": "QC explicado passo a passo",
  "why.5": "Shipping explicado",
  "why.6": "Warehouse explicado",
  "why.7": "Comparações úteis",
  "why.8": "Dicas de segurança",

  // How it works
  "how.title": "Como funciona?",
  "how.1.title": "Encontre uma categoria",
  "how.1.text": "Navegue pelas categorias do CSSBuy Spreadsheet.",
  "how.2.title": "Pesquise produtos",
  "how.2.text": "Encontre links e informações sobre produtos.",
  "how.3.title": "Verifique os links",
  "how.3.text": "Confira links, informações e detalhes disponíveis.",
  "how.4.title": "Confira medidas e QC",
  "how.4.text": "Verifique medidas, fotos QC e especificações.",
  "how.5.title": "Compare opções",
  "how.5.text": "Compare produtos, preços e vendedores.",
  "how.6.title": "Confirme os dados",
  "how.6.text": "Confirme informações atuais antes da compra.",

  // Popular guides
  "guides.title": "Guias populares",
  "guides.subtitle": "Recursos essenciais para compradores no CSSBuy Spreadsheet",
  "guides.review": "CSSBuy Review",
  "guides.review.desc": "Análise independente completa sobre QC, warehouse e shipping.",
  "guides.shipping": "CSSBuy Shipping Cost",
  "guides.shipping.desc": "Guia completo sobre custos, métodos e fatores de envio.",
  "guides.qc": "CSSBuy QC Guide",
  "guides.qc.desc": "Como verificar fotos QC, medidas e qualidade de produtos.",
  "guides.warehouse": "CSSBuy Warehouse Guide",
  "guides.warehouse.desc": "Entenda o processo de warehouse, storage e consolidação.",
  "guides.legit": "CSSBuy Legit?",
  "guides.legit.desc": "Análise independente de segurança, pagamento e confiabilidade.",
  "guides.coupon": "CSSBuy Coupon",
  "guides.coupon.desc": "Guia sobre cupons, promoções e códigos de desconto.",
  "guides.readmore": "Ler Mais",
  "pillars.title": "Guias & Artigos Detalhados",
  "pillars.subtitle": "Recursos aprofundados sobre QC, shipping, warehouse, segurança e mais para compradores CSSBuy.",

  // CTA section
  "cta.title": "Encontre seu próximo recurso no CSSBuy Spreadsheet",
  "cta.subtitle": "Acesse o site principal para explorar todos os produtos e categorias disponíveis.",
  "cta.btn1": "Explorar CSSBuy Spreadsheet",
  "cta.btn2": "cssbuy spreadsheet",
  "cta.btn3": "buy it now",

  // Safety
  "safety.title": "Segurança em primeiro lugar",
  "safety.text": "Verifique links, vendedores, medidas, QC, custos e políticas atuais. Nunca compartilhe sua senha e confirme informações importantes diretamente na plataforma correspondente.",
  "safety.btn": "Ver Guia de Segurança",
  "safety.disclaimer": "Este website é um recurso informacional independente. CSSBuy, vendedores, marketplaces e links externos são operados por suas respectivas partes. Informações, preços, disponibilidade e políticas podem mudar.",

  // FAQ
  "faq.title": "Perguntas Frequentes",
  "faq.1.q": "O que é CSSBuy Spreadsheet?",
  "faq.1.a": "CSSBuy Spreadsheet é uma planilha organizada com links, produtos, categorias e recursos de compra. Este é um recurso independente criado para ajudar compradores a encontrar informações úteis.",
  "faq.2.q": "Como usar CSSBuy Spreadsheet?",
  "faq.2.a": "Navegue pelas categorias, encontre links e informações relevantes, verifique detalhes como QC e medidas, e acesse o site principal para confirmar e completar sua compra.",
  "faq.3.q": "CSSBuy Spreadsheet é oficial?",
  "faq.3.a": "Não. Este website é um recurso informacional independente e não é afiliado, endossado ou operado pelo CSSBuy.",
  "faq.4.q": "Como verificar um link?",
  "faq.4.a": "Sempre acesse links diretamente e verifique a autenticidade do vendedor na plataforma correspondente antes de realizar qualquer compra.",
  "faq.5.q": "Como funciona o QC?",
  "faq.5.a": "QC (Quality Check) são fotos do produto tiradas no warehouse antes do envio. Permitem verificar qualidade, medidas e condições do item.",
  "faq.6.q": "Quanto custa o shipping?",
  "faq.6.a": "Os custos variam de acordo com peso, volume, destino e método de envio. Sempre confirme o preço final antes do pagamento.",
  "faq.7.q": "CSSBuy é legítimo?",
  "faq.7.a": "Este site apresenta informações independentes sobre o CSSBuy para ajudar compradores a tomar decisões informadas. Sempre verifique as informações atuais diretamente na plataforma.",
  "faq.8.q": "Existe cupom CSSBuy?",
  "faq.8.a": "Cupons e promoções são gerenciados pelo CSSBuy. Confira nosso Guia de Cupons para mais informações e verifique disponibilidade atual diretamente na plataforma.",

  // Footer
  "footer.desc": "Recurso informacional independente sobre CSSBuy Spreadsheet. Não somos afiliados ao CSSBuy.",
  "footer.links": "Links Úteis",
  "footer.categories": "Categorias",
  "footer.legal": "Legal",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.disclaimer": "Aviso Legal",
  "footer.about": "Sobre",
  "footer.contact": "Contato",
  "footer.copyright": "© 2026 cssbuybr.sbs — Recurso Independente. Não afiliado ao CSSBuy.",
  "footer.independent": "Recurso independente · Não afiliado ao CSSBuy",

  // Article page
  "article.backHome": "← Voltar ao Início",
  "article.toc": "Índice",
  "article.author": "Equipe Editorial cssbuybr.sbs",
  "article.updated": "Atualizado em",
  "article.disclaimer": "Aviso: Este conteúdo é independente e informacional. Não somos afiliados ao CSSBuy.",
  "article.readTime": "min de leitura",

  // About
  "about.title": "Sobre cssbuybr.sbs",
  "about.text1": "cssbuybr.sbs é um recurso informacional independente focado em CSSBuy Spreadsheet. Nosso objetivo é ajudar compradores a encontrar informações organizadas, guias úteis e recursos para tomar decisões de compra mais informadas.",
  "about.text2": "Este website não é afiliado, endossado ou operado pelo CSSBuy. Todas as informações são baseadas em pesquisa pública independente.",
  "about.mission": "Nossa Missão",
  "about.missionText": "Fornecer recursos organizados, precisos e úteis sobre CSSBuy Spreadsheet para compradores ao redor do mundo.",
  "about.disclaimer": "Aviso Legal",
  "about.disclaimerText": "Este website é um recurso informacional independente e não é afiliado, endossado ou operado pelo CSSBuy.",
};